import React from 'react';

import { Image } from 'components/Image';

export interface ImageProps {
  node: {
    fieldImage: {
      imagePath: string;
      alt: string;
    };
  };
}

export const ImageParagraph = ({ node }: ImageProps) => {
  return (
    <div className="blog-portfolio-image">
      {node.fieldImage?.imagePath && <Image imagePath={node.fieldImage.imagePath} alt={node.fieldImage.alt} />}
    </div>
  );
};
